import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Col, Card, CardBody } from "reactstrap";
// import { DoughnutChart } from "../../Constant";
import {   doughnutOption } from "./apexData";
import HeaderCard from "../../Common/Component/HeaderCard";
import configDB from "../../../Config/ThemeConfig";
import { useTranslation } from "react-i18next";
const primary =
  localStorage.getItem("default_color") || configDB.data.color.primary_color;
const secondary =
  localStorage.getItem("secondary_color") ||
  configDB.data.color.secondary_color;
const DoughnutChartClass = ({ statics }) => {
  const { t } = useTranslation();

  const pendingTasks= statics.pendingTasks
  const startedTasks = statics.startedTasks
  const onreviewTasks= statics.onreviewTasks
  const completedTasks= statics.completedTasks
  const expiredTasks =statics.expiredTasks

const doughnutData=  [completedTasks ,expiredTasks, startedTasks ,onreviewTasks,pendingTasks ]
  const doughnutsData = {
    labels: ["مكتملة",  "منتهية"  , "جاري العمل" ,"في المراجعة" , "لم تبدء"],
    datasets: [
      {
        data: doughnutData.map((count) => {
          return count;
        }),
        backgroundColor: [primary, secondary, "#51bb25" , "#a35bb3" , "#b3615b"],
      },
    ],
  };
  return (
    <Col md="4" >
      <Card>
        <HeaderCard title={t("احصائيات المهام")} />
        <CardBody className="chart-block">
          <Doughnut
            data={doughnutsData}
            options={doughnutOption}
            width={717}
            height={900}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DoughnutChartClass;
